import BaseAPI from "@/api/BaseAPI";

export class AppealsOrgAPI extends BaseAPI {
  constructor() {
    super('/appeal/org');
  }

  /**
   * @param {string} id appealID
   * */
  // getById(id,) {
  //     return this.http.get(`/get`, {data:{id}})
  // }

  /**
   * @param {number} orgId ownerId
   * */
  get(orgId) {
    return this.http.get(``, {data: {ownerId: orgId}})
  }

  /** TODO need change param info
   * @param {
   *    {
   *    id?: string,
   *    "nameShort": string,
   *   "name": string,
   *   "nameFull": string,
   *   "nameFullRp"?: string,
   *   "nameFullDp"?: string,
   *   "nameFullVp"?: string,
   *   "nameFullTp"?: string,
   *   "nameFullPp"?: string,
   *   "address": string,
   *   "inn": string,
   *   "kpp": string,
   *   "dataEntityCreateDate": Date,
   *   "dataEntityUpdateDate": Date,
   *   "appealType": string,
   *   "fileId": string,
   *   "accept": boolean
   *   }
   * } data
   * */
  setAppeal(data) {
    return this.http.put('', {data})
  }

  /**
   * @param {{
   *     "id": string,
   *   accept: boolean
   * }} data
   * */
  closeAppeal(data) {
    return this.http.post('/close', {data})
  }

  // /**
  //  * @param {string} id
  // * */
  // deleteAppeal(id){
  //     return this.http.delete('/delete', {data: {id}})
  // }

  deleteAppeal(id) {
    return this.http.delete(`?id=${id}`)
  }
}

export default new AppealsOrgAPI()